import { useState } from 'react';
import { useToast } from '@chakra-ui/react';
import cnpjService from '../services/cnpjService';

// Hook para busca de dados de empresa por CNPJ usando Brasil API
// Substitui o serviço anterior que não está mais disponível
export const useCNPJSearch = ({ fields, formMethods, cnpjControl, setCnpjControl }) => {
 const [isLoading, setIsLoading] = useState(false);
 const toast = useToast();

 const searchCNPJ = async (index) => {
  const cnpj = formMethods.getValues(`form.${index}.cnpj`)?.replace(/\D/g, '');

  try {
   setIsLoading(true);
   // Usando Brasil API - GET request com CNPJ na URL
   const { data } = await cnpjService.get(`/${cnpj}`);

   if (data?.razao_social) {
    updateFormWithCNPJData(data, index);
    setCnpjControl((prev) => [...prev, index]);
   } else {
    throw new Error('CNPJ não encontrado');
   }
  } catch (err) {
   handleSearchError(err, index);
  } finally {
   setIsLoading(false);
  }
 };

 const updateFormWithCNPJData = (cnpjData, index) => {
  // Mapeamento dos dados da Brasil API para o formato esperado pela aplicação
  const fields = {
   name: cnpjData.razao_social || '',
   address: `${cnpjData.logradouro || ''}, ${cnpjData.numero || ''} - ${cnpjData.bairro || ''}, ${cnpjData.municipio || ''} - ${cnpjData.uf || ''}`,
   fantasyname: cnpjData.nome_fantasia || cnpjData.razao_social || '',
   phone: cnpjData.ddd_telefone_1 || cnpjData.telefone_1 || '',
   cnpj: cnpjData.cnpj || '',
   cnae_list: `CNAE Principal: ${cnpjData.cnae_fiscal_descricao || ''} (${cnpjData.cnae_fiscal || ''})${
     cnpjData.cnaes_secundarios && cnpjData.cnaes_secundarios.length > 0 
       ? `\nCNAEs Secundários: ${cnpjData.cnaes_secundarios.map(cnae => `${cnae.descricao} (${cnae.codigo})`).join(', ')}` 
       : ''
   }`,
  };

  Object.entries(fields).forEach(([field, value]) => {
   formMethods.setValue(`form.${index}.${field}`, value);
  });
 };

 const clearCNPJ = (index) => {
  const excludedKeys = ['name', 'address', 'fantasyname', 'phone', 'cnae_list'];
  formMethods.reset(`form.${index}.cnpj`, '');
  const resetFields = getKeysWithPrefix(excludedKeys, index);
  formMethods.reset({ resetFields });
  formMethods.trigger(`form.${index}.cnpj`);

  const updatedCnpjControl = cnpjControl.filter((i) => i !== index);
  setCnpjControl(updatedCnpjControl);
 };

 function getKeysWithPrefix(excludedKeys, index) {
  const object = fields[index];
  const prefix = `form.${index}.`;
  const keysArray = Object.keys(object).filter((key) => excludedKeys.includes(key));
  const keysWithPrefix = keysArray.map((key) => prefix + key);

  return keysWithPrefix;
 }

 const handleSearchError = (error, index) => {
  toast({
   title: 'Nenhuma empresa encontrada',
   status: 'error',
  });

  formMethods.setError(`form.${index}.cnpj`, {
   type: 'custom',
   message: 'CNPJ não encontrado',
  });
 };

 return {
  searchCNPJ,
  clearCNPJ,
  isLoading,
 };
};
